import { Component, OnInit, Input } from '@angular/core';
import { StructureLayout } from '../../model/layout';
import { Structure } from '../../model/interfaces';
import { CvdsUtilsService } from '../../service/cvds-utils.service';

@Component({
	selector: 'cv-cvds-structure',
	templateUrl: './cvds-structure.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsStructureComponent implements OnInit {
	@Input() structure: Structure;
	@Input() index: number;

	constructor(private utilsService: CvdsUtilsService) {}

	fieldsModel = [];
	fieldsSections = [];

	async ngOnInit(): Promise<void> {
		const layout = new StructureLayout();
		this.fieldsModel = this.utilsService.mapFields(this.structure, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.structure, fieldName)) {
				this.fieldsSections.push({
					items: this.structure[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
